// removed by extract-text-webpack-plugin
module.exports = {"radioBox":"_32CZDrhQ71ej2Bq-ICDL2_","contentBox":"Ps5PbnCz3AHvO4frVEycA","title":"_1IrX5u1n6oG45l2h9gtmeE","text":"_2Y-zL5d1N4kJsU5IcxCFrP","content":"_3HVYCyAo1GYYJ2u65RrkaC","icon":"_3uJzRpydLJltoluCEB01f4"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/RadioBox/style.module.css
// module id = 443
// module chunks = 39